export function initLabelInstoreSelection(root = document) {
  root.querySelectorAll('[data-label-instore-selection]').forEach(form => {
    if (form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';
    const items = [...form.querySelectorAll('[data-label-instore-composer]:not(:disabled)')];
    const all = form.querySelector('[data-label-instore-all]');
    const count = form.querySelector('[data-label-instore-count]');
    const submit = form.querySelector('[data-label-instore-submit]');
    const suffix = count.textContent.replace(/^0\s*/, '');
    form.querySelector('[data-label-instore-all-control]').hidden = false;
    const update = () => {
      const selected = items.filter(input => input.checked).length;
      all.checked = items.length > 0 && selected === items.length;
      all.indeterminate = selected > 0 && selected < items.length;
      all.disabled = items.length === 0;
      count.textContent = `${selected} ${suffix}`;
      if (submit) submit.disabled = selected === 0;
    };
    all.addEventListener('change', () => {
      items.forEach(input => { input.checked = all.checked; });
      update();
    });
    items.forEach(input => input.addEventListener('change', update));
    update();
  });
}
